import { StyleRules, withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";

const styles: StyleRules = {
  container: {
    "& > *": {
      maxWidth: "inherit"
    },
    maxWidth: "inherit"
  }
};

const BaseContainer: React.FC<WithStyles<typeof styles>> = ({ classes, children }) => (
  <div className={classes.container}>{children}</div>
);

export const Container = withStyles(styles)(BaseContainer);
